<template>
 <div id="AdminFreqSetup">
   <div class="row">
      <div class="col-12">
     
         <h4 class="page-title text-truncate">{{$t('AdministrationFrequencySetup.AdminFreqSetupTitle')}}</h4>

        <div class="alert alert-fill-warning d-flex align-items-center m-3" role="alert" v-if="isReadOnly">
          <i class="mdi mdi-alert-circle me-2" style="font-size: 1.5rem;"></i>
          <div class="flex-grow-1">
            <span>{{ $t('Shared.ReadOnlyPermission') }}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12 col-md-3">                      
            <MdButton
              v-bind:Label="$t('AdministrationFrequencySetup.AddAdminFreq')" 
              v-bind:ClassProp="isReadOnly ? 'btn btn-primary my-3 btn-block' : 'btn btn-primary my-3 btn-block btn-login'"
              v-bind:IconClass="'ti-plus pr-1'"
              v-on:click="AddAdminFreq"
              v-bind:isReadOnly="isReadOnly"
              v-bind:Name="'btn_add_AdminFreqSetup'">
            </MdButton>
          </div>

           <div class="col-sm-12 col-md-2">  
              <MdSelect
                v-bind:Label="$t('Shared.Mode')"
                v-bind:Options="ModeList"
                v-bind:FieldDescription="'text'"
                v-bind:FieldCode="'value'"
                v-bind:AllowEmpty="false"
                v-bind:Model="ModelMode"
                v-bind:Multiple="false"              
                :Input="ChangeDropDownMode"
                />
          </div>

          <div class="col-sm-12 col-md-7 mb-4">
            <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
              <div class="input-group" dir="ltr">
                <input 
                  type="text" 
                  class="form-control"
                  :dir="dirInput"
                  v-model="parameter.SearchCriteria"   
                  @keyup.enter="getListing">
                  <div class="input-group-append">
                    <div class="input-group-append">
                      <MdButton 
                        v-bind:Name="'btnsearchinput'"
                        v-bind:VariantProp="'btn btn-sm search-attached'"
                        v-bind:IconClass="'mdi mdi-magnify'"
                        v-on:click="getListing">
                      </MdButton>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>              
        </div>
    </div>

      <div class="row">
        <div class="col-12 mt-2">
          <MdTitle v-bind:Text="$t('Shared.SearchElements')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
          <div class="row">
            <div class="col-md-12">
                <MdTable 
                  v-bind:fields="fields"
                  v-bind:items="items"
                  v-bind:totalRows="totalRows"
                  v-bind:isReadOnly="isReadOnly"
                  v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                  v-bind:currentPage="currentPage"
                  v-bind:perPage="perPage"                
                  v-bind:pageOptions="pageOptions"
                  :editIconEvent="EditAdminFreq"
                  v-bind:VisibleEditIcon="true"
                  :deleteIconEvent="RemoveAdminFreq"
                  v-bind:VisibleDeleteIcon="true"
                  :onRowSelected="onRowSelected"
                  :onFiltered="onFiltered"
                  :pageChanged="pageChanged"
                  :perPageFunction="PerPageFunction"
                  >
              </MdTable>
            </div>
          </div>
        </div>
    </div>
      
 </div>
</template>

<script>

import DrugFreqSetupHdrService from '@/services/drugfreqsetuphdrs.service';
import ShowMessage from '@/components/messages/ShowMessage.js';
import DBFunctions from '@/common/DBFunctions.js'
export default {
name: 'AdministrationFrequencyList',
 mixins: [ShowMessage, DBFunctions],
  data(){
    return{
      isReadOnly:false,
      dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
      Header:{},
      parameter:{
        SearchCriteria:'',
        PageNumber : 1,
        PageSize:0,
        Mode:"All",
      },
      OptionsRightMenu:{
        visible:false,
        btnvisible:false,
        ItemsList:[],
        favButtonAtion: false
      },
      ModelMode:{value:"All",text:"All"},
      ModeList:[
        {value:"All",text:"All"},
        {value:"Timed",text:"Timed"},
        {value:"Prn",text:"Prn"},
        {value:"Stat",text:"Stat"}
      ],
      ShowMessageIsEmpty:false,
      pageOptions: [5, 10, 15 ],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      filter: null,
      filterOn: [],
      items: [],         
      fields: [
        { key: 'description', sortable: true, label: this.$tc('Shared.Description'), class: 'text-rigth' },
        { key: 'code', sortable: true, label: this.$t('Shared.Code'), class: 'text-rigth hidden' },
        { key: 'mode', sortable: true, label: this.$t('Shared.Mode'), class: 'text-rigth' },
        { key: 'recurEveryDays', sortable: true, label: this.$t('AdministrationFrequencySetup.RecurEveryDays'), class: 'text-rigth' },        
        { key: 'timesPerDay', sortable: true, label: this.$t('AdministrationFrequencySetup.TimesPerDay'), class: 'text-center' },
        { key: 'hoursBetweenDoses', sortable: true, label: this.$t('AdministrationFrequencySetup.HoursBetweenDoses'), class: 'text-rigth' },
        { key: 'ccdaPeriodValue', sortable: true, label: this.$t('AdministrationFrequencySetup.CcdaPeriodValue'), class: 'text-center' } ,
        { key: 'ccdaPeriodValueHigh', sortable: true, label: this.$t('AdministrationFrequencySetup.CcdaPeriodValueHigh'), class: 'text-center' },
        { key: 'ccdaPeriodUnit', sortable: true, label: this.$t('AdministrationFrequencySetup.CcdaPeriodUnit'), class: 'text-center' },
        { key: 'excludeFromAdministration', sortable: true, label: this.$t('AdministrationFrequencySetup.ExcludeFromAdministration'), class: 'text-center' },
        { key: 'frequencyId', sortable: true, label: this.$tc('AdministrationFrequencySetup.FrequencyId'), class: 'text-center' },              
        ],
    }
  },

  methods:{
    ChangeDropDownMode(item){
      if(item){
        this.parameter.Mode = item.value;
        this.ModelMode = item;
        this.getListing();
      }
      
    },
    onRowSelected(){

    },
    onFiltered(){

    },
    pageChanged(page){
      this.currentPage = page;    
      this.getListing();   
    },
    PerPageFunction(perpage){
      this.perPage = perpage;  
      this.currentPage = 1;
      this.getListing();  
    },
    RemoveAdminFreq(row){       
        this.$bvModal.msgBoxConfirm(this.$t('Msg.DeleteRecord'), {
					title: this.$t('AdministrationFrequencySetup.DeleteAdminFreq'),
					okTitle: this.$t('Shared.TitleDelete'),
					cancelTitle: this.$t('Shared.BtnCancel'),
					footerClass: 'p-2',
					titleClass: 'modal-title modal-type-warning',
          id: 'modal_delete_adminFrequency'
				})
          .then(value => {
            if(value){             
               DrugFreqSetupHdrService.delete(row.code)
                .then(() => {
                  const index = this.items.findIndex(item => item.code === row.code) 
                  if (~index) {
                    this.items.splice(index, 1) 
                    this.getListing(); 
                  }
                })
                .catch((error) => {                 
                  this.showResponseErrorMessage(error);                  
                });
            }
          })
    },
    EditAdminFreq(row){
      this.$router.push({ name: "drugsadministrationfrequency-detail", params: { id: row.code } }).catch(()=>{});
    },
    AddAdminFreq(){
      this.$router.push({ name: "drugsadministrationfrequency-add"});
    }, 

    async getListing(){     
      this.parameter.PageNumber = this.currentPage;           
      this.parameter.PageSize = this.perPage;
         await DrugFreqSetupHdrService
          .getAll(this.parameter).then((response) => {      
              if (response.data) {                    
                this.items = response.data;
                let headerString = response.headers["x-pagination"];
                this.Header = JSON.parse(headerString);
                this.totalRows = this.Header.TotalCount;
                this.ShowMessageIsEmpty = this.items.length === 0 ? true : false;
              }                     
          })
          .catch(error => {                
            this.showResponseErrorMessage(error);
          });  
    }
  },

  async mounted(){
    this.OptionsRightMenu.visible = false;
    this.OptionsRightMenu.btnDrugOrdersInboxvisible = false;    
    this.OptionsRightMenu.ItemsList = [];
    this.$emit('onMenuRightBarDrugOrdersInbox', this.OptionsRightMenu);
    let layoutStatus = this.$store.state.layoutStatus;
    switch(layoutStatus) {
    case 'L0R1':
        this.OptionsRightMenu.favButtonAtion = true;
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
    break;
    case 'L1R0':
    case 'L1R1':
        this.OptionsRightMenu.btnvisible = false;
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
    break;
    default:
        this.OptionsRightMenu.favButtonAtion = true;
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
    } 
    await this.getListing();
  }
   
};
</script>


